import { Grid, Tab } from '@material-ui/core';
import {
  ChevronLeft,
  GetApp,
  CheckCircleRounded,
} from '@material-ui/icons';
import {
  getClassesById,
  getStudentOnClass,
  getTrainingById,
  setClassroomMemberAction,
  generateQRCode,
  getAllQRCode,
  getLastQRCode,
  launchCron,
} from '@webapps/business';
import {
  Button,
  Modal,
  ModalSideBar,
  PaginationNumbers,
  TextField,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import MessageBox from 'components/MessageBox';
import ModalConfirm from 'components/ModalConfirm/ModalConfirm';
import ProfilSidebar from 'components/ProfilSidebar';
import ProfilName from 'components/ProfilSidebar/Components/ProfilName';
import { ROUTES_PATH } from 'config/constants';
import React, { useEffect, useRef, useState } from 'react';

import ActionClasse from '../Classes/Components/ActionsClasse';
import CandidatsCard from './Components/CandidatsCard';
import { useHistory } from 'react-router-dom';
import Information from 'components/Icons/Information';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import AbsenceDeclarationModal from 'components/AbsenceDeclarationModal';
import { useLocation } from 'react-router-dom';
import Planning from './Components/Planning';
import StudentStatement from './Components/StudentStatement';
import StatementPeriodModal from './Components/StatementPeriodModal';
import ExportStatementsModal from './Components/ExportStatementsModal';
import ManyStudentStatement from './Components/ManyStudentStatement';
import AddPartner from 'pages/school/Partner/components/AddPartner';
import SchedulePlanner from './Components/SchedulePlanner';
import { CalendarProvider } from './Stores/CalendarProvider';
import EmargementContent from './Components/EmargementContent';
import NewModal from './Components/Modals/NewModal';
import { format, isSameDay } from 'date-fns';
import { fr } from 'date-fns/locale';
import ClassesDetailFilter from './Components/ClassesDetailFilter';

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;

const ClassesDetail = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { params, push } = useRouter();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);


  const { id: idParam, training: trainingParam } = params;
  const goToPlanning = searchParams.get('planning') === 'true';

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const [keyword, setKeyword] = useState('');
  const [tabValue, setTabValue] = useState(goToPlanning ? '2' : '1');
  const [openDeletePeriods, setOpenDeletePeriods] = useState(false);
  const [onDeletePeriods, setOnDeletePeriods] = useState(false);
  const studentRefs = useRef({});

  // Mise à jour du tab quand l'URL change
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const planningParam = searchParams.get('planning') === 'true';
    if (planningParam && tabValue !== '2') {
      setTabValue('2');
    }
  }, [location.search]);

  const [candidatId, setCandidatId] = useState(0);
  const [currentRefetchAbsenceHours, setCurrentRefetchAbsenceHours] = useState(null);

  const history = useHistory();

  const contactMember = (id) => {
    setCandidatId(id);
    handleOpenMessageBox();
  };



  const {
    data: { content: infoMembers = [], totalElements } = {},
    refetch,
    isLoading: isLoadingInfoMembers,
  } = useQuery(getStudentOnClass, {
    key: ['studentOnClass', page, idParam + keyword],
    variables: {
      keyword,
      id: idParam,
      status: 'ENROLLED',
      page: page - 1,
      size,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };
  const handleTabChange = (event, newValue) => setTabValue(newValue);

  const [viewProfil, setViewProfil] = useState(false);

  const [item, setItem] = useState("");

  const handleOpenViewProfil = () => {
    setViewProfil(true);
  };
  const handleCloseViewProfil = () => {
    setViewProfil(false);
  };

  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [currentId, setCurrentId] = useState();
  const handleOpenMessageBox = (id) => {
    setCurrentId(id);
    setOpenMessageBox(true);
  };
  const handleCloseMessageBox = () => {
    setOpenMessageBox(false);
  };

  const viewCV = (item) => {
    setItem(item);
    handleOpenViewProfil();
  };

  const viewAbsence = (item, refetchAbsenceHours) => {
    setItem(item);
    setCurrentRefetchAbsenceHours(() => refetchAbsenceHours);
    setAbsenceModalOpen(true);
  };

  const searchKeyword = (e) => {
    setKeyword(e.target.value);
    setPage(1);
  };

  const goToPreviousPage = () => {
    history.push(ROUTES_PATH.SCHOOL_CLASSES);
  };

  const { addToast } = useToast();

  const {
    error: errorMemberClassroomAction,
    isLoading: isLoadingMemberClassroomAction,
    isSuccess: isSuccessMemberClassroomAction,
    mutateAsync: mutateSetMemberClassroom,
  } = useMutation(setClassroomMemberAction);

  const deleteOnClass = (id) => {
    mutateSetMemberClassroom({
      id,
      action: 'exclude',
    });
  };

  useEffect(() => {
    if (errorMemberClassroomAction) {
      addToast({
        status: 'error',
        message: 'Erreur',
      });
    }
    if (isSuccessMemberClassroomAction) {
      addToast({
        status: 'success',
        message: 'Etudiant supprimé avec succès',
      });
      refetch();
      handleCloseViewConfirmDelete();
    }
  }, [isSuccessMemberClassroomAction, errorMemberClassroomAction]);

  const [selectedMember, setSelectedMember] = useState();

  const [viewConfirmDelete, setViewConfirmDelete] = useState(false);
  const [absenceModalOpen, setAbsenceModalOpen] = useState(false);
  const [downloadStatement, setDownloadStatement] = useState(false);
  const [student, setStudent] = useState();
  const [refStatement, setRefStatement] = useState(React.createRef());
  const [periodModalOpen, setPeriodModalOpen] = useState(false);
  const [statementPeriod, setStatementPeriod] = useState({
    startDate: new Date(currentYear, currentMonth, 1),
    endDate: new Date(currentYear, currentMonth + 1, 0)
  });
  const [isExportStatementsModalOpen, setIsExportStatementsModalOpen] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [isMultipleExport, setIsMultipleExport] = useState(false);
  const [isDownloadingStatement, setIsDownloadingStatement] = useState(false);
  const [showStatements, setShowStatements] = useState(false);
  const [absencesData, setAbsencesData] = useState([]);
  const [startMonth, setStartMonth] = useState(currentMonth);
  const [startYear, setStartYear] = useState(currentYear);
  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);
  const [htmls, setHtmls] = useState([]);
  const [htmlObjectForExport, setHtmlObjectForExport] = useState([]);
  const [onCloseDownloadStatementModal, setOnCloseDownloadStatementModal] = useState(null);
  const exportHtmls = useRef([]);
  const [openAddPartnerModal, setOpenAddPartnerModal] = useState(false);
  const [currentStudentId, setCurrentStudentId] = useState(null);
  const [currentStudentEmail, setCurrentStudentEmail] = useState(null);

  // États pour l'émargement
  const [isQRCodeModalOpen, setIsQRCodeModalOpen] = useState(false);
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    // Set the htmls in the window object for the ExportStatementsModal to use
    setHtmlObjectForExport(htmls);
    // Also update the ref for direct access
    exportHtmls.current = htmls;
  }, [htmls]);

  const handleDownloadStatement = (student, onClose) => {
    setStudent(student);

    setPeriodModalOpen(true);
    if (onClose) {
      setOnCloseDownloadStatementModal(() => {
        setIsExportStatementsModalOpen(false);
        onClose()
      })
    }
  };

  const handlePeriodConfirm = (startDate, endDate) => {
    setStatementPeriod({ startDate, endDate });
    setDownloadStatement(true);
  };

  const handleOpenViewConfirmDelete = (id) => {
    setSelectedMember(id);
    setViewConfirmDelete(true);
  };

  const handleCloseViewConfirmDelete = () => {
    setViewConfirmDelete(false);
  };


  const { data: classe = {} } = useQuery(getClassesById, {
    key: ['classe', idParam],
    variables: { id: idParam },
  });

  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', classe.training],
    variables: { id: classe.training },
  });

  // Queries et mutations pour l'émargement


  const { data: lastQRCode = {}, isLoading: isLoadingLastQRCode, refetch: refetchLastQRCode } = useQuery(getLastQRCode, {
    key: ['lastQRCode', date],
    variables: { classroomId: idParam },
  });

  const { mutateAsync: mutateGenerateQRCode, isLoading: isLoadingGenerateQRCode, data: dataGenerateQRCode } = useMutation(generateQRCode, {
    onSuccess: (data) => {
      // console.log("data", data);
    }
  });

  const { mutateAsync: mutateLaunchCron, isLoading: isLoadingLaunchCron, data: dataLaunchCron } = useMutation(launchCron, {
    onSuccess: (data) => {
      // console.log("data", data);
    }
  });

  // Handlers pour l'émargement
  const handleGenerateQRCode = async () => {
    const data = await mutateGenerateQRCode({ classroomId: idParam });
    // await refetchAllQRCode();
    await refetchLastQRCode();
  };

  const handleLaunchCron = async () => {
    const data = await mutateLaunchCron();
  };

  const handleOpenAddPartnerModal = (studentEmail, studentId) => {
    setCurrentStudentEmail(studentEmail)
    setCurrentStudentId(studentId)
    setOpenAddPartnerModal(true);
  };

  const handleCloseAddPartnerModal = (number) => {
    setOpenAddPartnerModal(false);
  };

  return (
    <div className={classes.container}>

      {
        downloadStatement && (
          <StudentStatement
            ref={refStatement}
            student={student}
            startDate={statementPeriod.startDate}
            endDate={statementPeriod.endDate}
            downloadStatement={downloadStatement}
            onDownloadComplete={() => setDownloadStatement(false)}
            setDownloadStatement={setDownloadStatement}

          />
        )
      }
      <div>
        {showStatements && absencesData.map((item) => {
          // Find the corresponding student from the selected students
          const studentObj = infoMembers.find(s => s.student.id === item.id)?.student;

          if (!studentObj) return null;



          // Calculate the dates again to ensure they're available
          let startDateValue = new Date(startYear, startMonth - 1, 1);
          startDateValue.setUTCDate(1);
          startDateValue.setUTCHours(0, 0, 0, 0);
          startDateValue = startDateValue.toISOString().split('T')[0];

          const endDateObj = new Date(endYear, endMonth, 0);
          const endDateValue = endDateObj.getFullYear() + '-' +
            String(endDateObj.getMonth() + 1).padStart(2, '0') + '-' +
            String(endDateObj.getDate()).padStart(2, '0');

          return (
            <ManyStudentStatement
              key={item.id}
              ref={el => studentRefs.current[item.id] = el}
              student={studentObj}
              startDate={startDateValue}
              endDate={endDateValue}
              absences={item.absences}
              setHtmls={setHtmls}
            />
          );
        })}
      </div>


      {/* <KPIClasseDetail data={[
        { value: classe?.label, icon: Group },
        { value: training?.label, icon: Work },
        { value: training?.degree?.label, icon: School },
        { value: training?.trainingType?.label, icon: Description },
      ]} /> */}
      <TabContext value={tabValue}>
        <div className={css({
          '& .MuiTabPanel-root': {
            padding: 0,
          },
        })}>
          <TabList
            className={css({
              paddingLeft: spacing(0),
              width: '100%',
            })}
            onChange={handleTabChange}
            indicatorColor="default"
            variant={window.innerWidth < 768 ? 'fullWidth' : 'standard'}
          >
            <Tab label="Classe" value="1"
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  minWidth: '12vw',
                  borderTopRightRadius: 5,
                  background: tabValue === '1' ? 'white' : '#F3F7FF',
                  color: tabValue === '1' ? '#152652' : '#5A6DA1',
                  fontWeight: tabValue === '1' ? 600 : 400,
                  '@media screen and (max-width: 768px)': {
                    width: '100%',
                  },
                }),
              }}

            />
            <Tab label="Planning" value="2"
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  minWidth: '12vw',
                  borderTopRightRadius: 5,
                  background: tabValue === '2' ? 'white' : '#F3F7FF',
                  color: tabValue === '2' ? '#152652' : '#5A6DA1',
                  fontWeight: tabValue === '2' ? 600 : 400,
                  '@media screen and (max-width: 768px)': {
                    width: '100%',
                  },
                }),
              }}

            />
            <Tab label="Emploi du temps" value="3"
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  minWidth: '12vw',
                  borderTopRightRadius: 5,
                  background: tabValue === '3' ? 'white' : '#F3F7FF',
                  color: tabValue === '3' ? '#152652' : '#5A6DA1',
                  fontWeight: tabValue === '3' ? 600 : 400,
                  '@media screen and (max-width: 768px)': {
                    width: '100%',
                  },

                }),
              }}
            />
          </TabList>

          <TabPanel value="1" className={css({
            background: 'white',
            borderRadius: '0 0 10px 10px',
            padding: '0 !important',
          })}>
            <Grid
              className={css({ background: 'white', padding: spacing(2.5) })}
              item
              xs={12}
            >
              {
                isLoadingInfoMembers ? (
                  <ClassesDetailFilter
                    goToPreviousPage={goToPreviousPage}
                    searchKeyword={searchKeyword}
                    idParam={idParam}
                    totalElements={totalElements}
                    isSameDay={isSameDay}
                    date={date}
                    setIsQRCodeModalOpen={setIsQRCodeModalOpen}
                    setIsExportStatementsModalOpen={setIsExportStatementsModalOpen}
                    page={page}
                  >
                    {[...Array(size/2)].map((_, index) => (
                      <CandidatsCard
                        key={index}
                        isLoading={true}
                      />
                    ))}
                  </ClassesDetailFilter>
                ) : infoMembers?.length > 0 ? (
                  <ClassesDetailFilter
                    goToPreviousPage={goToPreviousPage}
                    searchKeyword={searchKeyword}
                    idParam={idParam}
                    totalElements={totalElements}
                    isSameDay={isSameDay}
                    date={date}
                    setIsQRCodeModalOpen={setIsQRCodeModalOpen}
                    setIsExportStatementsModalOpen={setIsExportStatementsModalOpen}
                    page={page}
                  >
                    {infoMembers?.map((item, index) => (
                      <CandidatsCard
                        item={item}
                        refetch={refetch}
                        contactMember={() => contactMember(item?.student?.id)}
                        deleteMember={() => handleOpenViewConfirmDelete(item?.id)}
                        addAbsence={(id, refetchAbsenceHours) => viewAbsence(item, refetchAbsenceHours)}
                        id={item?.student?.id}
                        classId={idParam}
                        viewMember={() => viewCV(item)}
                        hideInfos={true}
                        hideAbsence={item?.classroom?.planning == null}
                        handleDownloadStatement={() => handleDownloadStatement(item?.student)}
                        handleOpenAddPartnerModal={handleOpenAddPartnerModal}
                      />
                    ))}
                  </ClassesDetailFilter>
                ) : (
                  <Grid className={classes.noResultContainer} container >
                    <Grid item className={classes.container2}>
                      <h1 className={cx(global.title, classes.h1)}> Commencez à inviter des apprenants </h1>
                      <div className={classes.containerInfo}>
                        <div className={classes.info}>
                          <Button
                            color="primary"
                            variant="contained"
                            fullWidth
                            onClick={() => history.push(ROUTES_PATH.SCHOOL_CLASSES, {
                              openInviteStudents: true,
                            })}
                            disableElevation
                            className={classes.btn}
                          >
                            Inviter un apprenant
                          </Button>
                          <div>
                            <p className={cx(global.infoText, classes.stepStyles)}> 1. Recherchez un apprenant pour votre formation. </p>
                            <p className={cx(global.infoText, classes.stepStyles)}> 2. Ajouter le à votre classe. </p>
                            <p className={cx(global.infoText, classes.stepStyles)} style={{ marginBottom: '20px' }}> 3. Permettez aux entreprises paternaire de voir vos apprenants. </p>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                )
              }

            </Grid>
            <PaginationNumbers
              onChange={handlePaginationChange}
              page={page}
              totalCount={totalElements}
              pageCount={size}
            />
          </TabPanel>

          <TabPanel value="2" className={css({
            display: 'flex',
            flexDirection: 'row',
            padding: '0 !important',
            // width: '100%',
          })}>
            <Planning
              idParam={idParam}
              infoMembers={infoMembers}
              classe={classe}
              training={training}
              from={"school"}
              setOpenDeletePeriods={setOpenDeletePeriods}
              onDeletePeriods={onDeletePeriods}
              setOnDeletePeriods={setOnDeletePeriods}
            />
          </TabPanel>

          <TabPanel value="3" className={css({
            padding: '0 !important',
          })}>
            <SchedulePlanner
              idParam={idParam}
            // allQRCode={allQRCode}
            />
          </TabPanel>
        </div>
      </TabContext>

      <ModalSideBar
        handleClose={handleCloseViewProfil}
        open={viewProfil}
        title={<ProfilName userId={item?.student?.id} absButton={true} />}
        button={item?.classroom?.planning &&
          <Button
            className={css({
              color: '#0060F9',
              // width: '100%',
              backgroundColor: '#F3F7FF',
              border: '1px solid #0060F9',
              fontWeight: 500,
              display: 'flex',
              justifyContent: 'space-between',
              marginRight: '20px',
              '&:hover': {
                border: '1px solid #0060F9', backgroundColor: '#0060F9',
                color: "white",
              },
            })}
            color="primary"
            variant="outlined"
            onClick={() => setAbsenceModalOpen(true)}
          >
            Déclarer une absence
          </Button>
        }
        width="700px"
      >
        <ProfilSidebar id={item?.student?.id} typeOrganism="school" classroomId={idParam} displayPlanning={true} />
      </ModalSideBar>

      <AbsenceDeclarationModal
        open={absenceModalOpen}
        student={item?.student}
        classroomId={idParam}
        onClose={() => setAbsenceModalOpen(false)}
        onConfirm={() => {
          if (currentRefetchAbsenceHours) {
            currentRefetchAbsenceHours();
          }
        }}
      />
      <Modal
        onCancel={handleCloseAddPartnerModal}
        open={openAddPartnerModal}
        title="Ajouter une entreprise"
        width="1200px"
        // titleFontSize={'20px'}
        titleFontWeigth={500}
        maxWdth={'80%'}
      >
        <AddPartner
          onClose={handleCloseAddPartnerModal}
          refetch={refetch}
          studentId={currentStudentId}
          studentEmail={currentStudentEmail}
        />
      </Modal>
      <Modal
        onCancel={handleCloseMessageBox}
        open={openMessageBox}
        // subTitle="Envoyez un message aux candidats et gardez contact dans votre
        // messagerie"
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({ display: 'flex', flexDirection: 'row' })}>
          <span>
            <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
          </span>
          <div className={css({ fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' })}>
            Envoyez un message aux candidats et gardez contact dans votre
            messagerie
          </div>
        </div>
        <MessageBox id={candidatId} onCancel={handleCloseMessageBox} />
      </Modal>

      <NewModal
        open={isQRCodeModalOpen}
        onCancel={() => setIsQRCodeModalOpen(false)}
        title="Émargement"
        subtitle="Scannez le QR Code pour marquer votre présence"
        image={{
          src: "https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png",
          srcSet: "https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png?scale-down-to=512 512w,https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png?scale-down-to=1024 1024w,https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png 1574w",
          sizes: "165.6842px",
          alt: "",
        }}
        actions={[
          {
            label: "Générer un nouveau QR Code",
            onClick: handleGenerateQRCode,
            type: "validateButton",
          },
          {
            label: "Lancer le cron",
            onClick: handleLaunchCron,
            type: "validateButton",
          }
        ]}
        className={css({
          maxHeight: '80vh',
        })}
      >
        <EmargementContent
          classroomId={idParam}
          isLoading={
            {
              isLoadingLastQRCode: isLoadingLastQRCode,
              isLoadingGenerateQRCode: isLoadingGenerateQRCode,
            }
          }
          lastQRCode={lastQRCode}
        // refetchAllQRCode={refetchAllQRCode}
        />
      </NewModal>

      <ModalConfirm
        cancelBtnTitle="Non"
        confirmBtnTitle="Oui"
        confirmFunction={() => deleteOnClass(selectedMember)}
        isLoading={isLoadingMemberClassroomAction}
        onClose={handleCloseViewConfirmDelete}
        open={viewConfirmDelete}
        title="Supprimer de la classe"
      >
        Êtes-vous sûr de vouloir Supprimer l'étudiant de la classe
      </ModalConfirm>

      <Modal
        onCancel={() => setOpenDeletePeriods(false)}
        open={openDeletePeriods}
        title="Supprimer le planning"
        resetPadding
      >
        <div className={classes.modalCreateClasseContainer}>
          <div className={classes.textContainer}>
            <div className={cx(global.subTitle, classes.subTitle)}>Êtes-vous sûr de vouloir supprimer le planning ?</div>
          </div>
          <div className={classes.buttonContainer}>
            <Button
              className={css({ borderRadius: '6px' })}
              color="primary"
              onClick={() => {
                setOpenDeletePeriods(false)
              }}
              variant="outlined"
            >
              Annuler
            </Button>
            <Button
              className={css({ borderRadius: '6px' })}
              color="primary"
              onClick={() => {
                setOnDeletePeriods(true)
              }}
              variant="contained"
            >
              Supprimer
            </Button>
          </div>
        </div>
      </Modal>

      <StatementPeriodModal
        open={periodModalOpen}
        onClose={() => setPeriodModalOpen(false)}
        onConfirm={handlePeriodConfirm}
        dateInterval={student?.dateInterval ? student?.dateInterval : undefined}
        onCloseDownloadStatementModal={onCloseDownloadStatementModal}
      />

      <ExportStatementsModal
        open={isExportStatementsModalOpen}
        onClose={() => setIsExportStatementsModalOpen(false)}
        students={infoMembers}
        setSelectedStudentsForExport={(students) => {
          // setSelectedStudents(students);
          // setIsMultipleExport(true);
        }}
        setShowStatements={setShowStatements}
        setAbsencesData={setAbsencesData}
        startMonth={startMonth}
        startYear={startYear}
        endMonth={endMonth}
        endYear={endYear}
        setStartMonth={setStartMonth}
        setStartYear={setStartYear}
        setEndMonth={setEndMonth}
        setEndYear={setEndYear}
        currentYear={currentYear}
        handleDownloadStatement={handleDownloadStatement}
        htmlObjectForExport={htmlObjectForExport}
        setHtmlObjectForExport={setHtmlObjectForExport}
        exportHtmlsRef={exportHtmls}
      />
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    height: '100%',
    padding: '50px',
    gap: '20px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    lineHeight: '100%',
    '@media (max-width:768px)': {
      padding: spacing(3, 2, 2, 2)
    },
  },
  container2: {
    backgroundColor: '#FFFFFF',
    height: "100%",
    borderRadius: 12,
    border: '1px solid #C0D9FF',
    padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    '@media screen and (max-width: 768px)': {
      padding: '20px',
    },
  },
  noResultContainer: {
    backgroundColor: '#F3F7FF',
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 75px - 298px)',
    padding: spacing(2.5),
    '@media (max-width:768px)': {
      margin: spacing(0),
    },
  },
  leftFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',

    '@media (max-width:880px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',

      '& button': {
        width: '100%',
        maxWidth: '100%',
      },

      "& div": {
        width: '100%',
      },
    },
  },
  leftFilterInput: {
    width: '100%',
    minWidth: '200px',
    width: '20vw',
    // backgroundColor: 'red !important',
  },
  rightFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    '@media (max-width:880px)': {
      gap: '10px !important',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
    },
  },
  containerInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    columnGap: '20px',
    width: '100%',
    '@media screen and (max-width: 768px)': {
      alignItems: 'center',
      flexFlow: 'column',
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column-reverse',
    }
  },
  stepStyles: {
    textAlign: 'center',
    margin: '10px 0 0 0',
    '@media screen and (max-width: 768px)': {
      textAlign: 'center',
      margin: '0 0 10px 0',
    },
  },
  h1: {
    textAlign: 'center',
    margin: '0px 0px 30px 0px',
    lineHeight: '110%',
  },
  paper: {
    padding: spacing(2.5),
  },
  containerSearch: {
    background: 'white',
    paddingBottom: spacing(2.5),
    borderRadius: 10,
    '@media only screen and (max-width:768px)': {
      // marginTop: spacing(3),
      // paddingTop: spacing(2.5),
    },
  },
  searchContainer: {
    marginTop: spacing(2),
  },
  button: {
    height: '42px',
  },
  emergenceButton: {
    height: '42px',
    backgroundColor: '#C0D9FF',
    color: '#0060F9',
    border: '1px solid transparent',
    transition: 'none',
    '&:hover': {
      border: '1px solid #0060F9',
      // filter: 'brightness(0.9)',
      backgroundColor: '#C0D9FF',
    },
  },
  buttonOutlined: {
    border: '1px solid #0060F9',
    '&:hover': {
      border: '1px solid #0060F9',
      filter: 'brightness(0.9)',
      backgroundColor: '#ffffffe6',
    },
    height: '42px',
  },
  returnButton: {
    color: '#5A6DA1',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    border: '1px solid #C0D9FF',
    backgroundColor: 'white',
    borderRadius: '20px',
    width: '100%',
    fontWeight: 600,
    maxWidth: '200px',

    '@media (max-width:880px)': {
      flexShrink: 0,
      width: 'calc(100% - 40px) !important',
      maxWidth: 'calc(100% - 40px) !important',
    }
  },
  modalCreateClasseContainer: {
    padding: 20,
  },
  textContainer: {
    paddingBottom: spacing(2),
  },
  subTitle: {
    color: "#5D75A8",
    margin: 6
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    gap: 10
  }
});

export default ClassesDetail;
